import { Button } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";

export const AiSparkButton = ({ onClick }: { onClick: () => void }) => (
    <Button
        size="sm"
        radius="md"
        variant="gradient"
        gradient={{ from: "violet", to: "grape", deg: 135 }}
        leftSection={<IconSparkles size={16} />}
        onClick={onClick}
    >
        Start a Conversation with Filters
    </Button>
);
